export const socialIconList = [
  {
    name: 'yelp',
    prefix: 'fab', // fab prefix for brands, fas for solid icons
    link: 'https://www.yelp.com/biz/ready-dental-henderson-2',
  },
  // Add further social links with the icon of choice and link here
  // check https://fontawesome.com/icons?d=gallery&s=brands for other brand icons
];
